<section class="loader">
  <se-fe-spinner
    [seFeDataSize]="900"
    [seFeDataAriaLabel]="title"
    [seFeDataCenter]="true"></se-fe-spinner>

  <div class="loader-message">
    <div class="loader-message__text">
      <h2 class="loader-message__title">{{ title }}</h2>
      <p class="loader-message__subtitle">{{ subtitle }}</p>
    </div>
  </div>
</section>
